<template>
  <div
    id="app"
    class="layout app-unified-theme"
    :style="appBackgroundStyle"
  >
    <NavBar></NavBar>
    <router-view/>
    <GlobalChatDock />
    <el-footer
      class="fix-to-bottom"
      style="margin-top: 50px;"
    >
        <div class="mundb-footer">
          <a
            style="color:black;"
            href="https://codeac.com.cn"
            target="_blank"
          >© {{ copyrightYearText }} CodeAC</a>
          &nbsp;
          <a
            href="https://beian.miit.gov.cn/"
            style="color:black"
            target="_blank"
          >京ICP备2022027035号-1</a>
        </div>
      </el-footer>
    </div>
</template>
<script>
import NavBar from '@/components/NavBar.vue'
import GlobalChatDock from './components/chat/GlobalChatDock.vue'

export default {
  name: 'App',
  components: {
    NavBar,
    GlobalChatDock
  },
  computed: {
    copyrightYearText() {
      const startYear = 2022;
      const currentYear = new Date().getFullYear();
      return currentYear <= startYear ? `${startYear}` : `${startYear}-${currentYear}`;
    },
    appBackgroundStyle() {
      return {
        background:
          'radial-gradient(circle at 8% 10%, rgba(14, 165, 233, 0.18), transparent 38%), radial-gradient(circle at 88% 2%, rgba(16, 185, 129, 0.15), transparent 35%), linear-gradient(180deg, #edf7ff 0%, #f2faf9 48%, #f7fcff 100%)',
        backgroundAttachment: 'fixed',
        minHeight: '100vh',
      };
    },
  },
 
}


</script>

<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0px;
}
.layout{
    border: 1px solid #d7dde4;
    background: #f5f7f9;
    position: relative;
    border-radius: 4px;
    overflow: hidden;
}
* {
  margin: 0;
  padding: 0;
}
/* 修改光标颜色 */
/* .ace_cursor {
  color: #fff !important;
} */
/* General environment setup */
html {
  /* background-color: black; */
  /* height: 100%; */
}
body {
  width: 100%;
  background-color: white;
  height: 100%;
}

#app.app-unified-theme {
  border: 0;
  border-radius: 0;
}

#app.app-unified-theme .fix-to-bottom {
  background: transparent !important;
  border-top: 0 !important;
}

#app.app-unified-theme .mundb-footer {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 10px 16px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.74);
  border: 1px solid rgba(56, 108, 149, 0.22);
  box-shadow: 0 10px 26px rgba(44, 92, 128, 0.14);
  backdrop-filter: blur(6px);
}

#app.app-unified-theme .mundb-footer a {
  color: #1f3f5c !important;
}


</style>
